import { CONFIG } from '../../APP/config/CONFIG.js';
/** A Console Output Watermark*/
export default class WATERMARK {
    constructor() {
        const charWidth = 64;
        const hr = '\n' + '-'.repeat(charWidth) + '\n';
        let watermark = '';
        watermark += hr;
        watermark += CONFIG.app.name + '_' + CONFIG.app.version + '\n';
        watermark += 'Author: ' + CONFIG.app.author + ', Last Modified: ' + CONFIG.app.lastModified + '\n';
        watermark += hr;
        console.log(watermark);
        // const data = [
        // 	{ Name: 'App', Value: CONFIG.app.name },
        // 	{ Name: 'Version', Value: CONFIG.app.version },
        // 	{ Name: 'Author', Value: CONFIG.app.author },
        // 	{ Name: 'Last Modified', Value: CONFIG.app.lastModified }
        // ];
        // console.table(data);
    }
}
